import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            Popular Kakobuy Spreadsheet Categories
          </h2>
          <p className="text-foreground-600 text-sm mt-3 max-w-xl">
            Browse our comprehensive directory of verified products across 14 categories. Every listing is reviewed and updated daily.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200/50 transition-all duration-300 cursor-pointer relative"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`Kakobuy Spreadsheet ${cat.name} category`}
                  title={`${cat.name} - Kakobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-heading font-bold text-base md:text-lg text-white whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-white/70 text-xs mt-0.5">
                    {cat.description.length > 55 ? cat.description.slice(0, 55) + "..." : cat.description}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer font-label"
          >
            View All Categories on Kaspreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}